/*
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-04-29 09:58:54
 */

import { useEffect, useRef } from "react";

export default function useBroadcastChannel<T = unknown>(name: string, handler: (e: MessageEvent<T>) => void) {
	const broadcastChannel = useRef<BroadcastChannel | null>(null);

	useEffect(() => {
		broadcastChannel.current = new BroadcastChannel(name);
		broadcastChannel.current.onmessage = (e) => {
			handler(e);
		};
	}, [name]);

	return (data: T) => {
		if (broadcastChannel.current) {
			broadcastChannel.current.postMessage(data);
		} else {
			throw new Error(`There is no BroadcastChannel '${name}'`);
		}
	};
}
